/**
 * @graph-stack mall
 * @graph-domain Operations
 * @graph-business i18next初期化。日本語/英語の翻訳リソースをロードしブラウザ言語検出で自動切替
 * @graph-connects none
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import jaCommon from './locales/ja/common.json';
import enCommon from './locales/en/common.json';

/** @graph-connects none */
export const defaultNS = 'common';
/** @graph-connects none */
export const resources = {
  ja: {
    common: jaCommon,
  },
  en: {
    common: enCommon,
  },
} as const;

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'ja',
    defaultNS,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

/** @graph-connects none */
export default i18n;
